import React, { useState } from 'react';
import { Link } from "react-router-dom";
import RightsCheck from '../General/RightsCheck';
import { scrollToTop } from '../Shared/ScrollOnTop';

const PrintCertificates_navbar = () => {

     
    return (
        <>
            <RightsCheck />
            <nav className={`navbar navbar-expand-lg navbar-module MenuSticky`}>
                <div className="container-fluid">
                    <div className="collapse navbar-collapse">
                        <ul className="navbar-nav m-auto">
                            <li className="nav-item">
                                <Link onClick={scrollToTop}  className="nav-link" to="/Certificate/PrintCertificates">Certificate Printing</Link>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
        </>
    );
}

export default PrintCertificates_navbar;
